import { useEffect } from 'react';
import moment from 'moment';
import eventApi from '_api/event';
import { convertToCurrentGMT } from '_utils/function';
import { NOT_PAYNOW, SELECTION_MODE_SINGLE } from '_utils/constant';

export function initializeForm(data, reset, fromReHost = false) {
  let collectionDate = moment().add(1, 'weeks').format('YYYY-MM-DD');
  let collectionTime = '10:00';
  let closingDate = moment().add(1, 'days').format('YYYY-MM-DD');
  let timeTo = '17:00';

  if (data.pickupTime && !fromReHost) {
    const localPickupTime = convertToCurrentGMT(data.pickupTime);
    const parts = localPickupTime.split(' ');
    if (parts.length >= 2) {
      collectionDate = parts[0].split('-').reverse().join('-');
      collectionTime = parts[1];
    }
  } else if (data.pickupTime && fromReHost) {
    const localPickupTime = convertToCurrentGMT(data.pickupTime);
    const parts = localPickupTime.split(' ');
    if (parts.length >= 2) {
      collectionTime = parts[1];
    }
  }
  if (data.pickupTimestamp && data.pickupDuration) {
    timeTo = moment((data.pickupTimestamp + data.pickupDuration) * 1000).format('HH:mm');
  }
  if (data.closingTime && !fromReHost) {
    const localClosingTime = convertToCurrentGMT(data.closingTime);
    const parts = localClosingTime.split(' ');
    if (parts.length >= 2) {
      closingDate = parts[0].split('-').reverse().join('-');
    }
  }

  let extraFieldsData = [];
  if (data.extraFields) {
    const list = Array.isArray(data.extraFields)
      ? data.extraFields
      : data.extraFields.list || [];
    extraFieldsData = list.map((link, idx) => ({
      id: link.id || `extlink-${idx}-${Date.now()}`,
      name: link.name || '',
      value: link.value || link.url || '',
    }));
  }

  const items = (data.products || []).map((p) => {
    let subItems = [];
    if (p.subItems) {
      subItems = p.subItems.map((si) => ({
        id: Date.now() + Math.random(),
        type: si.type || si.title || '',
        selectionMode: si.selectionMode || SELECTION_MODE_SINGLE,
        required: si.required === 1,
        trackInventory: si.trackInventory === true || si.trackInventory === 1 || si.trackInventory === 'true',
        list: (si.list || []).map((l) => ({
          id: Date.now() + Math.random(),
          name: l.name,
          price: l.price,
          maxQty: l.maxQty,
        })),
      }));
    }
    return {
      id: fromReHost ? Date.now() + Math.random() : (p.id || p.pid || Date.now() + Math.random()),
      name: p.name || '',
      description: p.description || '',
      price: p.price || '',
      image: p.photoUrls?.[0] || null,
      maxQuantity: p.maxQuantity,
      minOrderQty: p.minOrderQty,
      defaultQuantity: p.defaultQuantity,
      limitPerOrder: p.limitPerOrder,
      orderCount: p.orderCount,
      splitCasePurchase: p.splitCasePurchase || null,
      subItems,
    };
  });

  const formattedValues = {
    groupId: data.groupId,
    title: data.title || '',
    description: data.description || '',
    location: data.pickupAddress || data.location || '',
    closingDate,
    timeTo,
    collectionDate,
    timeFrom: collectionTime,
    banners: (data.photoUrls || []).map((url) => ({
      id: Math.random().toString(36).substring(2, 9),
      url,
    })),
    paynow: data.paynow,
    payable: data.payable,
    payTogether: Boolean(data.payTogether),
    payAfterClosing:
      data.paynow !== undefined && data.paynow !== null
        ? (data.paynow === NOT_PAYNOW || data.paynow === false)
        : Boolean(data.payAfterClosing),
    adminCost: data.adminCost || '',
    orderDiscountEnabled: Boolean(data.orderDiscountEnabled),
    orderDiscount: data.orderDiscount || null,
    extraFields: extraFieldsData,
    enableSafeLinks:
      data.extraFields && !Array.isArray(data.extraFields)
        ? Boolean(data.extraFields.enableSafeLinks)
        : false,
    termCond: data.termCond || '',
    importantNotes: data.termCond || '',
    bookingAddressRequired: Boolean(data.bookingAddressRequired),
    isDraft: fromReHost ? false : Boolean(data.isDraft),
    items: items.length > 0
      ? items
      : [{ id: 1, name: '', description: '', price: '', image: null }],
  };

  if (typeof reset === 'function') {
    reset(formattedValues);
  }
}

export default function useFetchEventDetail({ eventId, reset, addToast, fromReHost = false }) {
  useEffect(() => {
    if (eventId) {
      eventApi
        .getEventDetail({ eid: eventId, isGetProducts: true })
        .then((res) => {
          if (res && res.msgResp) {
            initializeForm(res.msgResp, reset, fromReHost);
          }
        }) // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          if (addToast) {
            addToast('Failed to load event details', { appearance: 'error', autoDismiss: true });
          }
        });
    }
  }, [eventId, reset, addToast, fromReHost]);
}
